@if (!closed) {
<ng-container class="container">
  <ng-content></ng-content>
  @if (mode === 'closeable') {
  <un-icon type="close" theme="outline" (click)="close()"></un-icon>
  }
</ng-container>
}
